import { NumberSchema, StringSchema, addMethod, number, string } from 'yup';

declare module 'yup' {
    interface StringSchema {
        isIp: (errorMessage?: string) => StringSchema;
        IsVersionNumber: (errorMessage?: string) => StringSchema;
        IsAlphaNumeric: (errorMessage?: string) => StringSchema;
    }

    interface NumberSchema {
        numberBetween: (min, max, canBeNull?: boolean, errorMessage?: string) => NumberSchema;
    }
}

const v4pattern = '^$|^(25[0-5]|2[0-4]\\d|1\\d{2}|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d{2}|[1-9]?\\d)){3}$';
const v4exact = new RegExp(v4pattern);

function isIp(errorMessage = 'errors.validation.generic.ip-address-not-valid') {
    return this.test('Ip is valid', errorMessage, function (value: any) {
        const { path, createError } = this;

        if (value === null || value === undefined || value === '') {
            return true;
        }

        return v4exact.test(value) || createError({ path, message: errorMessage });
    });
}

const versionNumberPattern = /^\d{1,3}\.\d{1,3}([a-zA-Z]?)$/;

const alphaNumeric = /^[a-z0-9]+$/i;

function IsVersionNumber(errorMessage = 'errors.validation.generic.not-valid-version-number') {
    return this.test('Version number is valid', errorMessage, function (value: any) {
        const { path, createError } = this;
        return versionNumberPattern.test(value) || createError({ path, message: errorMessage });
    });
}

function IsAlphaNumeric(errorMessage = 'errors.validation.generic.invalid-alpha-numeric-value') {
    return this.test('string is valid', errorMessage, function (value: any) {
        const { path, createError } = this;
        return alphaNumeric.test(value) || createError({ path, message: errorMessage });
    });
}

function numberBetween(min, max, canBeNull = false, errorMessage = 'errors.validation.number.between') {
    return this.test('Number is between', errorMessage, function (value: any) {
        const { path, createError } = this;
        if (canBeNull && (value === null || value === undefined)) {
            return true;
        }
        return (
            (!isNaN(value) && value >= min && value <= max) ||
            createError({ path, message: errorMessage, params: { min, max } })
        );
    });
}

addMethod<StringSchema>(string, 'isIp', isIp);
addMethod<StringSchema>(string, 'IsVersionNumber', IsVersionNumber);
addMethod<StringSchema>(string, 'IsAlphaNumeric', IsAlphaNumeric);
addMethod<NumberSchema>(number, 'numberBetween', numberBetween);
